<!-- 电影首页 -->
<template>
  <section class="filmMain">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'filmMain',
    components: {
      
    },
    data() {
      return {
        

      }
    },
    computed: {
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        return this.$route.path
      }
    },
    mounted() {

    },
    methods: {
      /**
       * 初始化
       * */
      
    }
  }
</script>

<style lang="scss" scoped>

</style>